<script>
import LoginModal from './LoginModal';

export default {
    components: { LoginModal },

    data() {
        return {
            modalOpen: false,
        };
	},
};
</script>

<template lang="pug" src='./template/Footer.pug' />
<style lang="stylus" src='./styles/Footer.styl' scoped/>
